import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import Card from 'components/Card';
import { observer, inject } from 'mobx-react';
import QuotesTable, { QUOTE_COLUMNS, QUOTE_CARDS, QUOTE_MIN_TABLE_WIDTH } from 'components/Tables/Quotes';
import * as DataList from 'components/DataList';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';

const PageWrapGray = styled('div')`
  padding:8px 12px 12px 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'quoteStore', 'viewStore') @observer
class TechnicianQuotesPage extends Component {

  render() {
    let content;
    let {
      quoteStore: {
        quotes: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={QUOTE_COLUMNS}
          cards={QUOTE_CARDS}
          minTableWidth={QUOTE_MIN_TABLE_WIDTH}
          noun="estimates"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="estimates" onRetry={() => this.props.quoteStore.loadQuotes()} />;
    }
    if (!isError && !isLoading) {
      content = <QuotesTable />
    }
    return (
      <div>
        <Helmet>
          <title>Estimates | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
        <Sticky enabled={true} top={0} innerZ={9}>          
            <SearchBars.Quote key={this.props.viewStore.listFiltersVersion} />
        </Sticky>
        
          <Card>
            {content}
          </Card>
        
        </PageWrapGray>
      </div>
    )
  }
};

export default TechnicianQuotesPage;